import React, { ReactNode, useEffect } from 'react';
import { orderNavigationSlice } from '../../../../store/order/orderNavigation/orderNavigationSlice';
import { SpaEscrowSubNavigation } from '../../../../components/order/escrow/escrowHeader/spa/SpaEscrowSubNavigation';
import { SpaBalancesExpectedHeader } from '../../../../components/order/escrow/escrowHeader/spa/SpaBalancesExpectedHeader';
import { loadEscrowBalancesAsync } from '../../../../store/order/escrow/escrowBalancesHeaderSlice';
import { useAppDispatch } from '../../../../store/store';

export interface ISpaOrderEscrowContainerProps {
  orderId: string;
  children: ReactNode;
}

export const SpaOrderEscrowLayout: React.FC<ISpaOrderEscrowContainerProps> = ({ orderId, children }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(orderNavigationSlice.actions.setup({ tab: 'Escrow' }));
    dispatch(loadEscrowBalancesAsync({ orderId }));
  }, [dispatch, orderId]);

  return (
    <>
      <SpaBalancesExpectedHeader />
      <SpaEscrowSubNavigation orderId={orderId} />
      {children}
    </>
  );
};
